module.exports = __webpack_public_path__ + "img/artwork.32b2b04b.png";